import type { DynamicFormAnswers } from '@api_patient/dynamic_forms_api.service';
import { storage } from '@visiba/std';
import type { BasketStorageData } from '../views/view_booking/hooks/use_booking_basket';

export const applicationSessionStorage = storage<{
	showAlias: boolean;
	dynamicForms: Record<Guid, Record<number, DynamicFormAnswers>>;
	bookingBasket: Record<number, BasketStorageData>;
	reschedulingReason: string; // Use when the reception is not known in the booking basket service
}>({ type: 'session' });
